import { render, staticRenderFns } from "./EleIcon.vue?vue&type=template&id=4a8934bf&scoped=true"
import script from "./EleIcon.vue?vue&type=script&lang=js"
export * from "./EleIcon.vue?vue&type=script&lang=js"
import style0 from "./EleIcon.vue?vue&type=style&index=0&id=4a8934bf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8934bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a8934bf')) {
      api.createRecord('4a8934bf', component.options)
    } else {
      api.reload('4a8934bf', component.options)
    }
    module.hot.accept("./EleIcon.vue?vue&type=template&id=4a8934bf&scoped=true", function () {
      api.rerender('4a8934bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EleIcon/EleIcon.vue"
export default component.exports